import Text, { TextProps } from '@vkontakte/vkui/dist/components/Typography/Text/Text';
import styled from '@material-ui/styles/styled';

export default styled(Text)({
  fontSize: 14,
  lineHeight: '18px',
}) as React.FC<TextProps>;
